var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavbarPart'),_c('router-view'),_c('FooterPart'),_c('div',{staticClass:"back_top",class:_vm.hide,attrs:{"title":"回頂部"},on:{"click":_vm.scrollTop}},[_c('font-awesome-icon',{staticClass:"fa_icon",attrs:{"icon":"fa-solid fa-angle-up"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }